"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarContentLayout = void 0;
const react_1 = __importDefault(require("react"));
function SidebarContentLayout({ sidebar, children }) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        sidebar,
        react_1.default.createElement("section", { "data-testid": "reschedule-main-content" }, children)));
}
exports.SidebarContentLayout = SidebarContentLayout;
//# sourceMappingURL=SidebarContentLayout.js.map